import React from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@epoch-ui/components/AlertDialog';

interface DeleteQuestionConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog displayed when deleting a question from the questionnaire or feedback form.
 * Warns users that all existing guest responses to this question will be permanently lost.
 *
 * @param open - Controls the visibility of the dialog
 * @param onOpenChange - Callback fired when the dialog open state changes
 * @param onConfirm - Callback fired when the user confirms deleting the question
 */
export const DeleteQuestionConfirmationDialog: React.FC<DeleteQuestionConfirmationDialogProps> = ({
  open,
  onOpenChange,
  onConfirm
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="tw-w-[400px] tw-gap-5">
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription className="!tw-mt-5 tw-text-dark-black">
            Existing responses will be lost if you delete this question.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => onOpenChange(false)}
            size="sm"
            className="tw-rounded-xl tw-border-light-grey tw-bg-light-grey"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={onConfirm}
            size="sm"
            className="tw-rounded-xl"
          >
            Delete question
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
